<template>
  <v-dialog v-model="selectIndicatorsDialog" width="700" persistent>
    <v-card-title
      :style="
        'background-color: ' +
        this.$store.state.config.siteConfig.toolbar_colour
      "
      class="text-h6 pl-1"
    >
      <v-btn
        v-if="indicators?.length"
        icon="mdi-close"
        variant="text"
        tile
        @click="selectIndicatorsDialog = false"
        aria-label="Select Indicator"
      />
      Map indicator data
    </v-card-title>
    <v-card class="pa-0" rounded="0">
      <div>
        <v-card-text
          v-if="!indicators?.length"
          class="text-center text-subtitle-1"
        >
          Currently you don't have enough indicators assigned to your client to
          show on Discovery Tool. Please contact support@localinsight.org for
          assistance
        </v-card-text>
        <div v-else>
          <v-card-text class="px-4 py-2">
            Select up to three indicators to explore on the map and uncover
            insights
          </v-card-text>

          <div class="list-wrapper">
            <Draggable v-model="indicators" item-key="id">
              <template v-slot:item="{ element: indicator }">
                <v-card-actions
                  :key="indicator.id"
                  class="indicator w-100 py-0 px-1 border-b-thin"
                  style="min-height: 44px"
                  @click.prevent="handleToggle(indicator)"
                >
                  <v-icon
                    icon="mdi-drag"
                    aria-label="draggable icon"
                    style="cursor: move"
                  />
                  <v-checkbox
                    v-model="localSelection"
                    color="primary"
                    :value="indicator"
                    hide-details
                  />
                  <div style="user-select: none">
                    {{ indicator.indicator_name }}
                  </div>
                  <v-spacer />
                </v-card-actions>
              </template>
            </Draggable>

            <!-- Warnings -->
            <v-alert
              v-if="limitExceeded || isSelectionEmpty"
              color="warning"
              class="ma-4 floatable-alert"
            >
              <div v-if="limitExceeded">
                <b>Selection Limit Exceeded</b>
                <div>
                  Selection limit reached. Please choose up to three indicators
                  to continue.
                </div>
              </div>
              <div v-else-if="isSelectionEmpty">
                <b>No indicators selected</b>
                <div>
                  Select at least one indicator from the list to continue.
                </div>
              </div>
            </v-alert>
          </div>
        </div>
      </div>
      <v-card v-if="indicators?.length" class="mt-5">
        <v-card-actions>
          <v-btn
            tile
            @click="selectIndicatorsDialog = false"
            variant="text"
            title="back to list"
            aria-label="close"
          >
            close
          </v-btn>
          <v-spacer />
          <v-btn
            color="success"
            tile
            :disabled="!localSelection.length || limitExceeded"
            variant="elevated"
            @click="updateMap"
            title="back to list"
            aria-label="Update map"
          >
            update map
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "DiscoveryToolSelectIndicator",
  emits: ["updateIndicators"],
  data: () => ({
    localSelection: [],
  }),
  components: {
    Draggable,
  },
  props: {},
  methods: {
    handleToggle(indicator) {
      if (this.localSelection.some((i) => i.id === indicator.id)) {
        this.localSelection = this.localSelection.filter(
          (i) => i.id !== indicator.id,
        );
      } else {
        this.localSelection.push(indicator);
      }
    },
    updateMap() {
      if (this.localSelection.length > 3) return;

      // sort the order according to this.indicators
      this.localSelection = this.localSelection.sort((a, b) => {
        const aIndex = this.indicators.findIndex((i) => i.id === a.id);
        const bIndex = this.indicators.findIndex((i) => i.id === b.id);
        return aIndex - bIndex;
      });

      this.selectedIndicators = this.$cloneDeep(this.localSelection);
      this.selectIndicatorsDialog = false;
      this.$emit("updateIndicators");
    },
  },
  computed: {
    selectIndicatorsDialog: {
      get() {
        return this.$store.getters["discoveryTool/selectIndicatorsDialog"];
      },
      set(val) {
        this.$store.commit("discoveryTool/setSelectIndicatorsDialog", val);
      },
    },
    selectedIndicators: {
      get() {
        return this.$store.getters["discoveryTool/selectedIndicators"];
      },
      set(val) {
        this.$store.commit("discoveryTool/setSelectedIndicators", val);
      },
    },
    indicators: {
      get() {
        return this.$store.getters["discoveryTool/indicators"];
      },
      set(val) {
        this.$store.commit("discoveryTool/setIndicators", val);
      },
    },
    limitExceeded() {
      return this.localSelection.length > 3;
    },
    isSelectionEmpty() {
      return !this.localSelection.length;
    },
  },
  watch: {
    selectIndicatorsDialog(open) {
      if (open) {
        this.localSelection = this.$cloneDeep(this.selectedIndicators);
      }
    },
  },
};
</script>

<style scoped>
.indicator:hover {
  background-color: #bfe0f8;
  transition: background-color 0.5s ease;
  cursor: pointer;
}
.list-wrapper {
  position: relative;
  height: 250px;
  overflow-y: auto;
}
.floatable-alert {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 1;
}
</style>
